import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const SurveyorGuard = ({ children }) => {
  const { isAuthenticated, role } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (role !== "Surveyor") {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default SurveyorGuard;
